import {
  UsersAccountsClient,
  OnboardingState,
  UpdateUserDto,
  UserAttributionDto,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig, { platformType } from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const usersAccountsClient = new UsersAccountsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetProfile = async () => {
  return (await usersAccountsClient.getActiveUserProfile()).data;
};

const handleUpdateUsername = async (username: string) => {
  try {
    const { data } = await usersAccountsClient.changeUsername({ username });
    return data;
  } catch {
    return;
  }
};

const handleUploadAvatar = async (avatar: File, label?: string) => {
  try {
    const profile = (await usersAccountsClient.uploadUserAvatar(avatar, label))
      .data;
    return profile;
  } catch {
    return;
  }
};

const handleUpdateUserCountry = async (countryCode: string) => {
  try {
    const { data } = await usersAccountsClient.registerCountry({ countryCode });
    return data;
  } catch {
    return;
  }
};

const handleUpdateUser = async (userInfo: UpdateUserDto) => {
  try {
    const user = (await usersAccountsClient.updateUser(userInfo)).data;
    return user;
  } catch {
    return;
  }
};

const handleGetOnboardingState = async () => {
  try {
    const onboardingState = (await usersAccountsClient.getUserOnboardingState())
      .data;
    return onboardingState;
  } catch {
    return;
  }
};

const handleUpdateOnboardingState = async (
  onboardingState: OnboardingState
) => {
  try {
    const newOnboardingState = (
      await usersAccountsClient.updateUserOnboardingState(onboardingState)
    ).data;
    return newOnboardingState;
  } catch {
    return;
  }
};

const handleSaveAttribution = async (
  dto: UserAttributionDto
): Promise<void> => {
  await usersAccountsClient.saveUserAttribution(platformType, dto);
};

export {
  handleGetProfile,
  handleUpdateUsername,
  handleUploadAvatar,
  handleUpdateUserCountry,
  handleUpdateUser,
  handleGetOnboardingState,
  handleUpdateOnboardingState,
  handleSaveAttribution,
};
